import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createLoadWorkflowRequestAction, getIsRecordLoaded, getRecordActionsIds, hasWorkflow, isWorkflowLoading } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { FrameSharedProps } from "../../types";
import { RowActionsComponent, RowActionsComponentProps } from "../RowActionsComponent";

type StateProps = Pick<RowActionsComponentProps, "actionIds" | "disabled" | "isWorkflowLoading">;
type DispatchProps = Pick<RowActionsComponentProps, "loadWorkflowActions">;

const mapStateToProps: MapStateToProps<StateProps, FrameSharedProps, IAppState> = (state, { dataSourceKey, recordId }) => ({
    actionIds: getRecordActionsIds(state, dataSourceKey),
    disabled: !getIsRecordLoaded(state, { dataSourceKey, recordId }),
    hasWorkflow: hasWorkflow(state, dataSourceKey),
    isWorkflowLoading: isWorkflowLoading(state, dataSourceKey),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, FrameSharedProps> = (dispatch, { dataSourceKey, recordId }) => ({
    loadWorkflowActions: () => dispatch(createLoadWorkflowRequestAction(dataSourceKey, recordId)),
});

export const RowActions = connect(mapStateToProps, mapDispatchToProps)(RowActionsComponent);
